import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
} from '@mui/material';

const PTODialog = ({ open, onClose, ptoData }) => {
  const available = (
    parseFloat(ptoData?.yearStart || 0) +
    parseFloat(ptoData?.ytdAccumulated || 0) -
    parseFloat(ptoData?.ytdUsed || 0)
  ).toFixed(2);

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="md" 
      fullWidth
      sx={{}}
    >
      <DialogTitle>PTO Hours Balance</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ py: 2 }}>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Year Start"
              type="number"
              fullWidth
              value={ptoData?.yearStart || '0'}
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="YTD Accumulated"
              type="number"
              fullWidth
              value={ptoData?.ytdAccumulated || '0'}
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="YTD Used"
              type="number"
              fullWidth
              value={ptoData?.ytdUsed || '0'}
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Available"
              type="number"
              fullWidth
              value={available}
              InputProps={{ readOnly: true }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PTODialog;
